<div class="personal-details-email-update-container" data-test-id="personal-details-email-update-container">
  <div class="personal-details-email-update-label">Email address</div>

  <div
    class="personal-details-email-update-content flex flex-between-stretch"
    data-test-id="personal-details-email-update-content"
  >
    @if (email) {
      <span class="personal-details-email-update-value" data-test-id="personal-details-email-update-value">
        {{ email }}
      </span>
    }
    @if (!email) {
      <span
        class="personal-details-email-update-value placeholder"
        data-test-id="personal-details-email-update-value-placeholder"
      >
        -
      </span>
    }

    <button
      (click)="showEditModal()"
      class="small-button"
      color="primary"
      data-test-id="personal-details-email-update-edit-button"
      mat-button
    >
      Edit
    </button>
  </div>
</div>
